import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import * as Fi from 'react-icons/fi';
import { BiAddToQueue } from 'react-icons/bi';
import cn from 'classnames';

import { Services, Table } from 'services/action';

import { Page, Button } from 'ui/components';
import useTable from 'ui/components/table';
import { SkeletonTable, SkeletonPageFooter } from 'ui/components/skeleton';

import tableConfig from './component/table.config';
import { FormPricing } from 'ui/screens/authorized/_shared';

const initialState = {
  isShow: false,
  isWarning: false,
};

const PricingScreen = () => {
  const History = useHistory();
  const Dispatch = useDispatch();
  const PricingTable = useTable('pricing', tableConfig);
  const StateTable = useSelector((state) => state?.Table?.data['pricing']);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Table.Request']
  );
  const [{ isShow, isWarning }, setState] = React.useState(initialState);

  const $handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      isWarning: false,
    }));
  };

  const $onSuccess = async () => {
    setState((prevState) => ({ ...prevState, isShow: false }));
    Dispatch(Table.$reload('pricing', StateTable));
  }

  const $onCheckService = async () => {
    const req = await Dispatch(Services.$getType());

    if (req?.message === 'success') {
      if (req?.data && req?.data?.length > 0) {
        return;
      } else {
        History.push('/onboarding-customer');
      }
    }
  };

  React.useEffect(() => {
    $onCheckService();
  }, []);

  return (
    <Page className="col-12 p-md-4 bg-white h-100" isOnboarding>
      <Page.Header
        isOnboarding={
          <div className="py-3 px-0 mt-5 mt-md-0">
            <div
              className="fw-semibold title mb-2 p-0"
              style={{ fontSize: 26 }}
            >
              Harga
            </div>
            <div
              className="page-pretitle fw-normal"
              style={{ textTransform: 'none', fontSize: 12 }}
            >
              Tetapkan harga baku untuk membantu Anda memasukkan harga secara
              otomatis
            </div>
          </div>
        }
        className="p-0"
      />
      <Page.Body className="p-md-3 px-3">
        <div className="sub-page-navigation mt-4 mt-md-0">
          <PricingTable.Tools>
            <button
              onClick={() =>
                setState((prevState) => ({ ...prevState, isShow: true }))
              }
              className="btn btn-primary py-1 ms-1"
            >
              <BiAddToQueue color="white" size="14" />
              <span className="d-none d-md-block ms-2">Tambah Skema Harga</span>
            </button>
          </PricingTable.Tools>
        </div>
        <div className="sub-page-body">
          <div className="row m-0 p-0">
            <div className={cn('col-md-12   m-0 p-0')}>
              {StateLoading ? (
                <SkeletonTable headerCount={4} bodyCount={10} />
              ) : (
                <PricingTable.Render />
              )}
            </div>
          </div>
        </div>
        <div className="sub-page-footer mt-2">
          {StateLoading ? <SkeletonPageFooter /> : <PricingTable.Pagination />}
        </div>

        <Modal
          show={isShow}
          onHide={() =>
            setState((prevState) => ({ ...prevState, isShow: false }))
          }
          backdrop="static"
          centered
          size="lg"
          enforceFocus={true}
        >
          <Modal.Header closeButton>
            <Modal.Title>Buat Skema Pricing</Modal.Title>
          </Modal.Header>
          <FormPricing
            onClose={() => {
              setState((prevState) => ({ ...prevState, isShow: false }));
            }}
            onSuccess={$onSuccess}
          />
        </Modal>
      </Page.Body>

      <Page.Footer className="justify-content-center gap-2 pt-3 border-top d-md-flex d-block mb-3 flex-wrap">
        <Button
          type="button"
          className="btn-secondary py-3"
          onClick={() => History.push('/onboarding-services')}
        >
          Sebelumnya
        </Button>
        <Button
          type="button"
          className="btn-primary py-3"
          onClick={() => {
            if (StateTable?.pricing?.total === 0 || StateTable === null) {
              setState((prevState) => ({
                ...prevState,
                isWarning: true,
              }));
            } else {
              History.push('/onboarding-customer');
            }
          }}
        >
          Selanjutnya
        </Button>
      </Page.Footer>

      <Modal
        show={isWarning}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-warning" />
          <Fi.FiAlertTriangle className="mb-2 text-warning" size={90} />
          <h3>Anda belum mengisi daftar harga</h3>
          <p className="text-warning fw-semibold">
            Data harga diperlukan untuk menentukan harga pengiriman.
          </p>
          <p className="text-secondary fw-semibold">
            Pengisian data harga dilakukan nanti.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-between align-items-center w-100 gap-2">
            <div className="">
              <Button className="btn btn-white" onClick={$handleClose}>
                Isi sekarang
              </Button>
            </div>
            <div className="">
              <Button
                className={'btn btn-primary'}
                onClick={() => History.push('/onboarding-customer')}
              >
                Atur nanti
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </Page>
  );
};

export default PricingScreen;
